export const AVATAR_PALETTE = [
  "#E57373", // red
  "#F06292", // pink
  "#BA68C8", // purple
  "#7986CB", // indigo
  "#64B5F6", // blue
  "#4DD0E1", // cyan
  "#4DB6AC", // teal
  "#81C784", // green
  "#AED581", // light green
  "#FFD54F", // amber
  "#FFB74D", // orange
  "#A1887F", // brown
  "#90A4AE", // blue grey
  "#F48FB1", // light pink
  "#80DEEA", // light cyan
  "#CE93D8", // light purple
  "#C9A84C", // champagne gold
] as const

export type AvatarColor = typeof AVATAR_PALETTE[number]

/**
 * Derive initials from a display name.
 * "Ron Saylor" → "RS"
 * "Ron"        → "R"
 * ""           → "?"
 */
export function getInitials(displayName: string | null | undefined): string {
  if (!displayName?.trim()) return '?'
  const words = displayName.trim().split(/\s+/)
  if (words.length === 1) return words[0][0].toUpperCase()
  return (words[0][0] + words[words.length - 1][0]).toUpperCase()
}

/**
 * Returns a foreground color (black or white) that contrasts
 * well against the given background hex color.
 */
export function contrastColor(hex: string): string {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  // Perceived luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.55 ? '#000000' : '#ffffff'
}
